export const getDeltaAnnexInitialDataURL = () => {
  return `/customer/delta-annexure/initial/`;
};

export const searchDeltaAnnexuresDataURL = (page) => {
  return `/customer/delta-annexure/search/?page=${page}`;
};

export const commentDeltaAnnexureURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/comment/`;
};

export const saveDeltaBillDetailsURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/save_bill_details/`;
};

//saveDeltaBillSubmissionProofAndDateURL
export const saveDeltaBillSubmissionProofAndDateURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/upload_bill/`;
};
//viewBillSubmissionProofDetailsURL
export const viewBillSubmissionProofDetailsURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/bill-submission-details/`;
};
export const printDeltaAnnexureURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/?print=true`;
};

export const viewRegularisedAnnexureURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/`;
};

export const deleteDeltaAnnexuresURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/delete/`;
};

export const downloadDeltaAnnexuresURL = () => {
  return `/customer/delta-annexure/download/`;
};

export const deltaAdditionalAnnexureDetailsURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/details/`;
};

export const deltaCNAnnexureDetailsURL = (annexureId, type) => {
  return `customer/delta-annexure/${annexureId}/details/?type=${type}`;
};

export const createAdditionalAnnexureURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/create_next_annexure/`;
};

export const deltaCreateAdHocCNURL = (annexId) => {
  return `customer/delta-annexure/${annexId}/create_adhoc_annexure/`;
};

export const removeBillDetailsURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/remove-bill-details/`;
};
